// extracted by mini-css-extract-plugin
export default {"PageError":"PageError_PageError__3AGJd","PageErrorButton":"PageError_PageErrorButton__gGj+q"};